import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    GET_BOOKMARK_LIST,
} from "./Bookmark.type";
import BookmarkService from "../services/Bookmark.service";

export const getBookmarkList = createAsyncThunk(
    GET_BOOKMARK_LIST,
    async () =>{
        const response = await BookmarkService.getBookmarkList();
        return response.data;
    }
)
